<ng-template appProductMenuFooterInflatorContainer></ng-template>
